import { useContext, useEffect, useState } from 'react'
import { inputContext } from '../../context/inputsContext'
import { SummaryOfVisits, useGetVisits } from '../../lib/hooks/api'

const useData = () => {
  const [mockData, setMockData] = useState<
    | {
        visits: { [key: number]: SummaryOfVisits | null }
        kpi: { [key: string]: number }
      }
    | undefined
  >()

  const { values } = useContext(inputContext)

  const { data: visits } = useGetVisits(
    values.startDate,
    values.endDate,
    values.location?.gatewayMacs || [],
    values.interval,
    !!values.startDate &&
      !!values.endDate &&
      !!values.location &&
      values.startDate < values.endDate,
  )

  useEffect(() => {
    setMockData(visits)
  }, [values, visits])

  return mockData
}

export default useData
